import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAssumedRole } from '../core/AssumedRoleContext';

/*
 * Small key indicator next to the page title: appears while project
 * roles are assumed, names the entered projects in its tooltip and
 * links to the project area where the checkboxes allow leaving again.
 * Project roles only apply to the booking/hosting endpoints — the
 * upcoming partner-scoped office assume will get its own indicator.
 */
export function AssumedRoleBadge() {
  const { t } = useTranslation();
  const { assumedProjects } = useAssumedRole();

  if (!assumedProjects.length) {
    return null;
  }

  const tooltip = t('project.assumedTooltip', {
    projects: assumedProjects.map((project) => project.caption).join(', '),
  });

  return (
    <Link
      to="/dashboard/projects"
      className="assumed-role-indicator"
      title={tooltip}
      aria-label={tooltip}
    />
  );
}
